import axios from "axios"

const paramsSerializer = (params) => {
    const Qs = require("qs")
    return Qs.stringify(params, { encode: false })
}

export const createApplication = (headers, id, data) => {
    return axios.post(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/client/create-partner/${id}`,
        data,
        {
            headers
        }
    )
}

export const updateApplication = (headers, id, data) => {
    return axios.put(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/client/${id}`,
        data,
        {
            headers
        }
    )
}

export const findById = (headers, id) => {
    return axios.get(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/client/${id}`,
        {
            headers
        }
    )
}

export const findByMST = (headers, params) => {
    return axios.get(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/find-by-tin`,
        {
            headers,
            params,
            paramsSerializer
        }
    )
}

export const uploadLogo = (headers, id, data) => {
    return axios.put(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/client/${id}/upload-logo`,
        data,
        {
            headers
        }
    )
}

export const findClientsOther = (headers, id, params) => {
    return axios.get(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/client/${id}/client-other`,
        {
            headers,
            params,
            paramsSerializer
        }
    )
}

export const getLogoByAppId = (headers, appId) => {
    return axios.get(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/client/get-logo-by-app-id/${appId}`,
        {
            headers,
            responseType: "arraybuffer"
        }
    )
}

